<template>
  <div id="nav">
    <div id="nav-btn">
      <router-link to="/" class="btns">{{ $t("nav.home") }}</router-link>
      <router-link to="/role" class="btns">{{ $t("nav.role") }}</router-link>
      <router-link to="/video" class="btns">{{ $t("nav.video") }}</router-link>
      <router-link to="/news" class="btns">{{ $t("nav.news") }}</router-link>
    </div>
    <div id="nav-lang">
      <span class="lang-btns" :class="this.$i18n.locale == 'zh' ? 'lang-active':''" @click.stop="changeLang('zh')">中</span> |
      <span class="lang-btns" :class="this.$i18n.locale == 'en' ? 'lang-active':''" @click.stop="changeLang('en')">EN</span> |
      <span class="lang-btns" :class="this.$i18n.locale == 'ja' ? 'lang-active':''" @click.stop="changeLang('ja')">JA</span>
    </div>
    <div id="nav-icon">
      <a target="_blank" href="http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=vhb5T6xc8VzQjtD6opz2Xpc8c6tLzUVb&authKey=faKMd2%2BcnglR07Wiieu3%2FtRrspcL6BaR3dvYwmR%2B9hdv1OhID4I284oiqmUDs4wq&noverify=0&group_code=928900991"><img src="../assets/images/QQ.png" alt="QQ" class="icon-btns"></a>
      <a target="_blank" href="https://www.taptap.cn/app/233514"><img src="../assets/images/taptap.png" alt="taptap" class="icon-btns"></a>
      <a target="_blank" href="https://space.bilibili.com/1663803541"><img src="../assets/images/bilibili.png" alt="bilibili" class="icon-btns"></a>
      <a target="_blank" href="https://www.3839.com/a/142950.htm"><img src="../assets/images/bao.png" alt="好游快爆" class="icon-btns"></a>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
    }
  },
  methods: {
    changeLang(lang){
      this.$i18n.locale = lang
    },
  }
};
</script>

<style scoped lang="scss">
#nav {
  width: 1920px;
  height: 97px;
  position: fixed;
  left: 0;
  top: 0;
  background-image: url("../assets/images/nav-back.png");
  background-size: 100%;
  background-repeat: no-repeat;
  z-index: 999;
}
#nav-btn {
  position: absolute;
  left: 300px;
  bottom: 0;
  text-align: center;
  // 注释避免字体大小转为rem
  font-size: 18px;/*no*/
}
.btns:hover {
  background-image: url("../assets/images/btn-hover.png");
  background-size: 100%;
  background-repeat: no-repeat;
  font-weight: 600;
  color: #fff;
}
.btns {
  width: 250px;
  height: 145px;
  display: inline-block;
  margin: 0 20px;
  line-height: 210px;
  text-decoration: none;
  color: #888888;
  &.router-link-exact-active {
    //router-link激活选中时的状态
    background-image: url("../assets/images/btn-active.png");
    background-size: 100%;
    background-repeat: no-repeat;
    font-weight: 600;
    color: white;
  }
}
#nav-lang{
  width: 200px;
  position: absolute;
  right: 250px;
  top: 40px;
  text-align: center;
  color: #838383;
  font-size: 12px;/*no*/
}
.lang-btns{
  cursor: pointer;
  margin: 0 12px;
}
.lang-active{
  color: white;
}
#nav-icon{
  position: absolute;
  right: 30px;
  top: 30px;
}
.icon-btns{
  width: 35px;
  padding: 0 7px;
  cursor: pointer;
}
</style>
